import { render, staticRenderFns } from "./WorksCategory.vue?vue&type=template&id=28c9f5d0&scoped=true&"
import script from "./WorksCategory.vue?vue&type=script&lang=js&"
export * from "./WorksCategory.vue?vue&type=script&lang=js&"
import style0 from "./WorksCategory.vue?vue&type=style&index=0&id=28c9f5d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c9f5d0",
  null
  
)

export default component.exports